module.exports = __webpack_public_path__ + "22_amta.jpg?e37cd3b0a3aa5a8593c15274d993baa0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/22_amta.jpg
// module id = 181
// module chunks = 0